import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

export interface NoteModalData {
  note: string;
  isEditing: boolean;
}

@Component({
  selector: 'app-marker-note-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './marker-note-modal.component.html',
  styleUrls: ['./marker-note-modal.component.scss'],
})
export class MarkerNoteModalComponent {
  @Input() visible: boolean = false;
  @Input() note: string = '';
  @Input() isEditing: boolean = false;

  @Output() save = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  currentNote: string = '';

  ngOnChanges(): void {
    this.currentNote = this.note;
  }

  onSave(): void {
    this.save.emit(this.currentNote);
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onDelete(): void {
    this.delete.emit();
  }

  onBackdropClick(): void {
    this.onCancel();
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
}
